<div class="container" my-5>
  <div class="card" #appendTo>
    <div class="card-body no-border">
      <div class="card-title">
        <h3 style="text-align: left;" class="page-header"><fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'sliders']"></fa-icon> Research Data Export</h3>
      </div>

      <form [formGroup]="searchForm"  class="k-form-inline">

        <div class="k-form-field">
          <label class="form-label col-2 k-label" for="evaluation_id">Evaluation</label>
          <div class="col-7">
            <kendo-dropdownlist id="evaluation_id" formControlName="evaluation_id"
                                [data]="evaluations" [valuePrimitive]="true" textField="evaluation_name" valueField="id"
                                [defaultItem]="{ id: null, evaluation_name: 'Select...' }" appAutoFocus>
            </kendo-dropdownlist>
            <div *ngIf="evaluation_id?.invalid" class="alert alert-danger">
              <div *ngIf="evaluation_id?.errors?.['required']">Evaluation  required.</div>
            </div>
          </div>
        </div>

        <div class="k-form-field">
          <label class="form-label col-2 k-label" >Organisation</label>
          <div class="col-7">
            <div class="component-container">
              <kendo-formfield showHints="always">
                <kendo-multiselect [data]="organisationList" textField="organisation_name" [valuePrimitive]="true" valueField="id" formControlName="organisations"></kendo-multiselect>
              </kendo-formfield>
            </div>
          </div>
        </div>

        <div class="k-form-field">
          <label class="form-label col-2 k-label" >Unit of Study</label>
          <div class="col-7">
            <div class="component-container">
              <kendo-formfield showHints="always">
                <kendo-multiselect [data]="unitOfStudyList" textField="unit_of_study" valueField="id" formControlName="units"></kendo-multiselect>
              </kendo-formfield>
            </div>
          </div>
        </div>

        <div class="k-form-field">
          <label class="form-label col-2">Review created between</label>
          <div class="col-7" >
            <kendo-daterange>
              <kendo-label text="Start">
                <kendo-dateinput [format]="format" kendoDateRangeStartInput [(value)]="dateRange.start" formControlName="start"></kendo-dateinput>
              </kendo-label>
              <kendo-label text="End">
                <kendo-dateinput [format]="format" kendoDateRangeEndInput [(value)]="dateRange.end" formControlName="end"></kendo-dateinput>
              </kendo-label>
            </kendo-daterange>
          </div>
        </div>

        <div class="k-form-field">
          <label class="form-label col-2 k-label" for="evaluation_id">Content</label>
          <div class="col-7">
            <kendo-dropdownlist id="content_id" formControlName="content_id"
                                [data]="contents" [valuePrimitive]="true" textField="text" valueField="value"
                                [defaultItem]="{ value: null, text: 'All reviews' }" >
            </kendo-dropdownlist>
<!--            <div *ngIf="evaluation_id?.invalid" class="alert alert-danger">-->
<!--              <div *ngIf="evaluation_id?.errors?.['required']">Content  required.</div>-->
<!--            </div>-->
          </div>
        </div>

        <div class="k-form-field">
          <div class="button-container">
            <button kendoButton (click)="onSearchAction()" class="btn btn-primary" [disabled]="searchForm.invalid">Search</button>
            <button kendoButton (click)="onExportAction()" class="btn btn-secondary" [disabled]="!canPrint">Export</button>
          </div>
        </div>

      </form>

      <kendo-grid #grid style="height: calc(100vh - 200px); min-height: 400px;"
        [kendoGridBinding]="gridData" [sortable]="false" [filterable]="false" [pageable]="true" [pageSize]="pageSize">
        <kendo-grid-excel [fileName]="fileName"></kendo-grid-excel>
        <kendo-grid-column [width]="180" *ngFor="let d of dataMap" [field]="d.field_name" [title]="d.heading"></kendo-grid-column>
        <ng-template kendoPagerTemplate>
          <kendo-pager-info *ngIf="pageSize > 0"></kendo-pager-info>
        </ng-template>

      </kendo-grid>
    </div>
  </div>

</div>
